export default __webpack_public_path__ + "static/AcidGrotesk-Regular-4475d51d7b5934d6146037e9bf2f3ef9.woff";